import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Home from './views/Home.vue'
import RoleManagement from './views/RoleManagement.vue'
import UserManagement from './views/UserManagement.vue'
import ModuleManagement from './views/ModuleManagement.vue'
import NavigationManagement from './views/NavigationManagement.vue'
import ChartManagement from './views/ChartDataManagement.vue'
import TestShell from "./views/TestShell";
Vue.use(Router)
const createRouter = () => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    }, {
      path: '/home',
      component: Home,
      children: [
        {
          path: '/admin/role',
          component: RoleManagement,
          name: 'role',
          subhead: 'Administration',
          icon: 'fa fa-cogs mr-5',
          meta: {
            auth: true
          },
          description: 'role-management'
        }, {
          path: '/admin/module',
          component: ModuleManagement,
          name: 'Modulkonfiguration',
          subhead: 'Administration',
          icon: 'fa fa-cogs mr-5',
          meta: {
            auth: true
          },
          description: 'role-management'
        }, {
          path: '/admin/user',
          component: UserManagement,
          name: 'user',
          meta: {
            auth: true
          },
          description: 'role-management'
        }, {
          path: '/admin/navigation',
          component: NavigationManagement,
          name: 'navigation',
          meta: {
            auth: true
          },
          description: 'role-management'
        }, {
          path: '/admin/charts',
          component: ChartManagement,
          name: 'charts',
          meta: {
            auth: true
          },
          description: 'role-management'
        }, {
          path: '/*',
          component: TestShell,
          meta: {
            auth: true
          }
        }
      ]
    }
  ]
})
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}

const router = createRouter()
export default router
